import axios from "axios";
import { useEffect, useState } from "react";
import { getUsername } from "helper/helper";

const baseURL =
  window.env?.VARS_BACKEND_URL ?? process.env.REACT_APP_SERVER_DOMAIN;
axios.defaults.baseURL = baseURL;

/** custom hook */
export default function useFetch(query) {
  const [getData, setData] = useState({
    isLoading: false,
    apiData: undefined,
    status: null,
    serverError: undefined,
  });

  useEffect(() => {
    //if (!query) return;

    const fetchData = async () => {
      try {
        setData((prev) => ({ ...prev, isLoading: true }));

        const { username } = !query ? await getUsername() : "";

        const { data, status } = !query
          ? await axios.get(`api/user/${username}`)
          : await axios.get(`/api/${query}`);

        setData((prev) => ({ ...prev, isLoading: false }));
        if (status === 201) {
          //setData((prev) => ({ ...prev, isLoading: false }));
          setData((prev) => ({ ...prev, apiData: data, status }));
        }

        //setData((prev) => ({ ...prev, isLoading: false }));
      } catch (error) {
        setData((prev) => ({ ...prev, isLoading: false, serverError: error }));
      }
    };
    fetchData();
  }, [query]);

  return [getData, setData];
}

export function useFetchProto(query) {
  const [getData, setData] = useState({
    isLoading: false,
    apiData: undefined,
    status: null,
    serverError: undefined,
  });

  useEffect(() => {
    //if (!query) return;

    const fetchData = async () => {
      try {
        setData((prev) => ({ ...prev, isLoading: true }));

        const { username } = !query ? await getUsername() : "";

        const { data, status } = !query
          ? await axios.get(`api/Usuarios/${username}`)
          : await axios.get(`/api/${query}`);

        setData((prev) => ({ ...prev, isLoading: false }));
        if (status === 201) {
          //setData((prev) => ({ ...prev, isLoading: false }));
          setData((prev) => ({ ...prev, apiData: data, status }));
        }

        //setData((prev) => ({ ...prev, isLoading: false }));
      } catch (error) {
        setData((prev) => ({ ...prev, isLoading: false, serverError: error }));
      }
    };
    fetchData();
  }, [query]);

  return [getData, setData];
}
